import * as url from "../../helpers/url_helper";
import { apiCall, fetchApi, processDeleteResponse } from "./apiService";

/**
 * Loads store handles from API with error handling
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Array|null>} Array of store handles or null if error
 */
export const loadStoreHandlesData = async (notifyError) => {
    return await apiCall(
        url.AUTO_BCL,
        'GET',
        null,
        notifyError,
        "Failed to load store handles"
    );
};

/**
 * Creates a new store handle
 * @param {Object} storeHandleData - Store handle data
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Created store handle data or null if error
 */
export const createStoreHandle = async (storeHandleData, notifyError) => {
    return await apiCall(
        url.AUTO_BCL,
        'POST',
        storeHandleData,
        notifyError,
        "Auto BCL Creation failed"
    );
};

/**
 * Updates an existing store handle
 * @param {Object} storeHandleData - Store handle data with id and update_records
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Updated store handle data or null if error
 */
export const updateStoreHandle = async (storeHandleData, notifyError) => {
    return await apiCall(
        url.AUTO_BCL,
        'PUT',
        storeHandleData,
        notifyError,
        "Auto BCL updated failed"
    );
};

/**
 * Deletes a store handle
 * @param {number} id - Store handle ID to delete
 * @param {Function} notifySuccess - Success notification function
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<boolean>} True if successful, false otherwise
 */
export const deleteStoreHandle = async (id, notifySuccess, notifyError) => {
    try {
        const { response, results } = await fetchApi(url.AUTO_BCL, 'DELETE', { id });
        return processDeleteResponse(
            response,
            results,
            notifySuccess,
            notifyError,
            "Auto BCL Deleted successfully",
            "Auto BCL Deletion failed"
        );
    } catch (error) {
        if (notifyError) {
            notifyError("Auto BCL Deletion failed");
        }
        return false;
    }
};

